import type { ReactNode } from 'react'

/** The centred card every sign-in screen uses. */
export function AuthShell({ title, sub, children, width = 380, logo }: { title: ReactNode; sub?: ReactNode; children: ReactNode; width?: number; logo?: string | null }) {
  return (
    <div className="min-h-full flex items-center justify-center p-4 sm:p-6" style={{ background: 'radial-gradient(circle at 20% 10%, #eef2ff, #f8fafc 50%), #f8fafc' }}>
      <div className="card w-full p-6 sm:p-7 shadow-xl shadow-indigo-900/5" style={{ maxWidth: width }}>
        <div className="flex items-center gap-3 mb-6">
          {logo ? <img src={logo} alt="" className="w-10 h-10 rounded-xl object-contain bg-white shrink-0" /> : <div className="w-10 h-10 rounded-xl text-white font-extrabold flex items-center justify-center shrink-0" style={{ background: 'linear-gradient(135deg,#6366f1,#14b8a6)' }}>t4</div>}
          <div className="min-w-0">
            <div className="font-bold text-[16px]">{title}</div>
            {sub && <div className="text-muted text-[12px]">{sub}</div>}
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}

export function FormError({ children }: { children: ReactNode }) {
  if (!children) return null
  return <div role="alert" className="mb-3 rounded-lg bg-red-50 border border-red-200 text-red-700 px-3 py-2 text-[12.5px]">{children}</div>
}

export function FormNote({ children }: { children: ReactNode }) {
  if (!children) return null
  return <div role="status" className="mb-3 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-800 px-3 py-2 text-[12.5px]">{children}</div>
}

/** Provider buttons: Google and Microsoft sign-in, and the company's SAML identity provider. */
export const PROVIDER_LABELS: Record<string, string> = { google: 'Continue with Google', azure: 'Continue with Microsoft', saml: 'Continue with your company sign-in' }
